import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "../Home/publicPages.css";
import "../Home/authPages.css";
import "./TraineeSignup.css";

const BASE_PATH = process.env.REACT_APP_BASE_PATH || "/als";

export default function TraineeSignUp() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { id } = e.target;
    const value =
      id === "mobileNo"
        ? e.target.value.replace(/\D/g, "").slice(0, 10)
        : e.target.value;
    setFormData({ ...formData, [id]: value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.mobileNo)) {
      setError("Mobile number must be exactly 10 digits");
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      mobile_no: formData.mobileNo,
      password: formData.password,
    };

    try {
      const response = await AxiosInstance.post("companies/signup", payload);
      if (response.status === 201 || response.status === 200) {
        navigate("/trainee-signin");
      }
    } catch (err) {
      console.error("Signup error:", err);
      let errorMessage = "Failed to sign up. Please try again.";
      const errorData = err.response?.data?.error;
      if (typeof errorData === "string") {
        errorMessage = errorData;
      } else if (typeof errorData === "object" && errorData !== null) {
        const firstKey = Object.keys(errorData)[0];
        const firstError = errorData[firstKey];
        errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
      }
      if (
        errorMessage.toLowerCase().includes("email") &&
        errorMessage.toLowerCase().includes("already exists")
      ) {
        errorMessage = "A trainee already exists with this email.";
      }
      setError(errorMessage);
    }
  };

  return (
    <div className="als-auth-page trainee-auth-page">
      <div className="als-auth-shell">
        <aside className="als-auth-brand">
          <div className="als-auth-brand-inner">
            <p className="als-auth-eyebrow">Learner portal</p>
            <h1>Start your learning journey.</h1>
            <p>
              Create a free account to enroll in courses, track progress, and
              apply to internships on Open Learnings.
            </p>
            <ul className="als-auth-points">
              <li>
                <span>✓</span> Access curated courses and batches
              </li>
              <li>
                <span>✓</span> Apply to internship opportunities
              </li>
              <li>
                <span>✓</span> Build your learner profile
              </li>
            </ul>
          </div>
        </aside>
        <div className="als-auth-panel">
          <div className="auth-forms-container">
            <h3>Create trainee account</h3>
            <p className="als-auth-lead">
              Join Open Learnings as a learner and get started in minutes.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="d-flex gap-3 mb-3">
                <div className="flex-fill">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    className="form-control"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="flex-fill">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    className="form-control"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="mobileNo">Mobile No</label>
                <input
                  type="tel"
                  id="mobileNo"
                  className="form-control"
                  inputMode="numeric"
                  maxLength={10}
                  pattern="\d{10}"
                  title="Enter a 10-digit mobile number"
                  required
                  value={formData.mobileNo}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  className="form-control"
                  required
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {typeof error === "string"
                    ? error
                    : Object.values(error).map((msg, i) => (
                        <div key={i}>{msg}</div>
                      ))}
                </div>
              )}

              <button type="submit" className="btn1">
                Sign Up
              </button>
            </form>

            <div className="als-auth-footer-links">
              <small>
                Already have an account?{" "}
                <Link to="/trainee-signin" className="green-hover-link1">
                  Sign In
                </Link>
              </small>
              <small>
                <a href={BASE_PATH} className="green-hover-link1">
                  Home
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
